<template>
  <div>
    <v-menu
      bottom
      left
      v-model="dialogMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="d-flex align-center">
          <v-btn
            class="mr-2 button"
            outlined
            large
            v-bind="attrs"
            v-on="on"
            @click="openMenuEvent()"
          >
            <v-icon size="20" class="mr-1">mdi-account-multiple</v-icon>
            <span class="button-text text-capitalize"
              >Seleccionar audiencia</span
            >
          </v-btn>
        </div>
      </template>
      <v-card class="pa-4 overflow-y" color="white" width="400" height="500">
        <v-row class="ma-0 my-2" justify="space-between" align="center">
          <v-btn class="mr-2" outlined small @click="setRules()">
            <span class="filter-button">Borrar</span>
          </v-btn>

          <span class="mr-2 font-weight-bold">Categorías</span>
          <v-btn class="mr-2" small color="#1b273e" @click="closeMenu()">
            <span class="filter-button white--text">Listo</span>
          </v-btn>
        </v-row>

        <hr />
        <v-row class="py-2">
          <v-expansion-panels accordion elevation="0">
            <v-expansion-panel
              class="py-1 filter-item"
              cols="12"
              elevation="0"
              v-for="(rule, index) in getRuleCategories"
              :key="`${rule}-${index}`"
            >
              <v-expansion-panel-header class="header-auto py-0">
                <v-checkbox
                  hide-details
                  class="shrink"
                  dense
                  multiple
                  color="#1b273e"
                  :label="rule"
                  :value="rule"
                  v-model="rules_category_selected"
                  @change="includeAllRuleOptions(rule)"
                  @click.stop
                >
                  <template v-slot:label>
                    <span class="black--text wc-caption-2">{{
                      labels[rule]
                    }}</span>
                  </template>
                </v-checkbox>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="pl-4 pt-2">
                  <hr />
                  <v-col
                    class="py-1 filter-item overflow-y"
                    cols="12"
                    v-for="(option, index) in getRuleDefaultValues(rule)"
                    :key="`${option}-${index}`"
                  >
                    <v-checkbox
                      hide-details
                      class="shrink"
                      dense
                      multiple
                      color="#1b273e"
                      v-model="rules_selected[rule]"
                      :label="option.name"
                      :value="option._id"
                    >
                      <template v-slot:label>
                        <span class="black--text wc-caption-2">{{
                          option.name
                        }}</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-card>
    </v-menu>
    <v-checkbox
      v-model="setNotificationsEnabled"
      :label="getCategoryLabel"
    >
    </v-checkbox>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex/dist/vuex.common.js';

export default {
  props: {
    benefit: String,
    event: String,
    publication: String,
    productService: String,
    editMode: {
      type: Boolean,
      default: false,
    },
    savedRules: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      dialogMenu: false,
      setNotificationsEnabled: false,
      labels: {
        affiliationTypes: 'Tipos de membresías',
        branches: 'Secciones locales',
        memberStatus: 'Estatus de miembros',
        subgroups: 'Subgrupos',
      },
      rules_default: {},
      rules_category_selected: [],
      rules_selected: {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
      },
      hasLoadedSavedRules: false,
    };
  },
  watch: {
    savedRules(newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.hasLoadedSavedRules = false;
      }
    },
  },
  computed: {
    ...mapState('audienceRules', ['audience_rules']),
    getRuleCategories() {
      return Object.keys(this.rules_default);
    },
    getCategoryLabel() {
      const baseLabel = `Enviar notificación para los miembros en las categorías de `
      const { benefit, event, publication, productService } = this.$props;
      const labels = {
        benefit: 'este beneficio',
        event: 'este evento',
        publication: 'esta publicación',
        productService: 'este producto',
      };
      const labelKey = Object.entries({ benefit, event, publication, productService }).filter(
        ([key, value]) => !!value
      )[0][0];
      return !!labels[labelKey] ? baseLabel + labels[labelKey] : 'Enviar notificación';
    },
  },
  methods: {
    ...mapActions('audienceRules', [
      'fetchOrganizationAudienceRules',
      'getAudienceRuleByCategoryId',
      'createAudienceRules',
      'updateAudienceRule',
      'sendEmailsByAudienceRule',
    ]),
    ...mapMutations('notification', ['show']),

    async getAudienceRules() {
      try {
        await this.fetchOrganizationAudienceRules();
      } catch (error) {
        console.log(error);
      }
    },

    includeAllRuleOptions(key = null) {
      if (!key) return;
      if (![...this.rules_category_selected].includes(key)) {
        this.rules_selected[key] = [];
      } else {
        this.rules_selected[key] = this.rules_default[key].map(
          (rule) => rule._id
        );
      }
    },

    getRuleDefaultValues(key = null) {
      if (!key) return [];
      return this.rules_default[key];
    },

    setRules(
      selected_category = [],
      selected_rules = {
        affiliationTypes: [],
        branches: [],
        subgroups: [],
        memberStatus: [],
      }
    ) {
      this.rules_category_selected = selected_category;
      this.rules_selected = selected_rules;
    },

    async createRules({ benefit = null, event = null, publication = null, productService = null }) {
      try {
        const payload = {
          benefit: benefit,
          event: event,
          publication: publication,
          productService: productService,
        };
        const response = await this.createAudienceRules({
          ...payload,
          ...this.rules_selected,
        });
        if (response.status) {
          if (this.setNotificationsEnabled) await this.sendEmails();
        }
      } catch (error) {
      } finally {
        this.dialogMenu = false;
        this.setRules();
      }
    },

    async updateRules({ benefit = null, event = null, publication = null, productService = null }) {
      try {
        const categories = {
          benefit: benefit,
          event: event,
          publication: publication,
          productService: productService,
        };
        await this.updateAudienceRule({
          categoryId: this.getCurrentCategoryId(categories),
          payload: {
            ...categories,
            ...this.rules_selected,
          },
        });

        if (this.setNotificationsEnabled) await this.sendEmails();
      } catch (error) {
      } finally {
        this.dialogMenu = false;
        this.setRules();
      }
    },

    async saveRules(categories = {}) {
      const categoryId = this.getCurrentCategoryId(categories);
      if (!categoryId) return { status: false };
      const { status } = await this.getAudienceRuleByCategoryId(categoryId);
      if (status) {
        return await this.updateRules(categories);
      }
      return await this.createRules(categories);
    },

    async sendEmails() {
      try {
        const categoryId = this.getCurrentCategoryId(this.$props);
        const response = await this.sendEmailsByAudienceRule(categoryId);

        if(response.status) {
          this.show({
            color: "success",
            text: "Notificaciones enviadas con éxito.",
          });
        }
      } catch (error) {
        this.show({
          text: 'Error al enviar notificaciones',
          color: 'error',
        });
      }
    },

    closeMenu() {
      this.dialogMenu = false;
    },

    getCurrentCategoryId(categoryObject = {}) {
      const { benefit, event, publication, productService } = categoryObject;
      return Object.values({ benefit, event, publication, productService })
        .filter(Boolean)
        .join('');
    },

    async openMenuEvent() {
      if (this.savedRules !== undefined) {
        if (this.hasLoadedSavedRules) {
          return;
        }
        this.hasLoadedSavedRules = true;
        const hasRules = Object.keys(this.savedRules).some(
          (key) => this.savedRules[key]?.length > 0
        );
        if (hasRules) {
          const selected_category = Object.keys(this.savedRules).filter(
            (key) =>
              this.savedRules[key].length > 0 &&
              this.savedRules[key].length === this.rules_default[key]?.length
          );
          this.setRules(selected_category, this.savedRules);
          return;
        }
        this.setRules([], { memberStatus: ['ACTIVE'] });
        return;
      }

      this.hasLoadedSavedRules = false;
      const { data: rules, status } = await this.getAudienceRuleByCategoryId(
        this.getCurrentCategoryId(this.$props)
      );

      if (!status) {
        this.setRules([], { memberStatus: ['ACTIVE'] });
        return;
      };

      const selected_category = Object.keys(rules).filter(
        (key) =>
          rules[key].length > 0 &&
          rules[key].length == this.rules_default[key].length
      );

      this.setRules(selected_category, rules);
    },
  },
  async mounted() {
    await this.getAudienceRules(); // save  audience rules inside state
    this.rules_default = this.audience_rules; // clone audience rules
  },
};
</script>
